module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/bg_intro03-db451e5b3835377eb2e57533c2c30898.jpg";